import { LoadFilesTypes } from './actionTypes';

export const updateFile = (file: any) => {
    return {
        type: LoadFilesTypes.UPDATE_FILE,
        payload: file
    };
};

export const updateFileSuccess = (data: any) => ({
    type: LoadFilesTypes.UPDATE_FILE_SUCCESS,
    payload: data
});

export const updateFileFail = (error: any) => ({
    type: LoadFilesTypes.UPDATE_FILE_FAIL,
    payload: error
});
